module.exports = __webpack_public_path__ + "static/bsas018.thumb-3112eb859b86d38130664c73a51d8493.jpg";